import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';

const MyProfile = () => {
  const { user, updateProfile, changePassword } = useAuth();
  const [profile, setProfile] = useState({
    fullName: user?.fullName || '',
    username: user?.username || '',
    email: user?.email || '',
    walletAddress: user?.walletAddress || '',
  });
  const [pwForm, setPwForm] = useState({ current: '', newPw: '', confirm: '' });
  const [profileMsg, setProfileMsg] = useState('');
  const [pwMsg, setPwMsg] = useState({ text: '', type: '' });

  const handleProfileSave = async (e) => {
    e.preventDefault();
    const result = await updateProfile(profile);
    if (result.success) {
      setProfileMsg('Profile updated successfully!');
    } else {
      setProfileMsg(result.error || 'Update failed');
    }
    setTimeout(() => setProfileMsg(''), 3000);
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    if (pwForm.newPw.length < 6) { setPwMsg({ text: 'Password must be at least 6 characters', type: 'error' }); return; }
    if (pwForm.newPw !== pwForm.confirm) { setPwMsg({ text: 'Passwords do not match', type: 'error' }); return; }
    const result = await changePassword(pwForm.current, pwForm.newPw);
    if (result.success) {
      setPwMsg({ text: 'Password changed successfully!', type: 'success' });
      setPwForm({ current: '', newPw: '', confirm: '' });
    } else {
      setPwMsg({ text: result.error, type: 'error' });
    }
    setTimeout(() => setPwMsg({ text: '', type: '' }), 3000);
  };

  const inputClass = "w-full bg-[#1a2333] border border-[#2a3a4a] rounded-lg px-4 py-3 text-white text-sm focus:border-yellow-400/50 focus:outline-none";

  return (
    <div>
      <h1 className="text-2xl lg:text-3xl font-bold text-yellow-400 mb-6">My Profile</h1>

      {/* Personal Info */}
      <div className="bg-[#0d1117] border border-[#1a2333] rounded-2xl p-6 mb-6">
        <h2 className="text-white font-bold text-lg mb-1">Personal Information</h2>
        <div className="h-px bg-gradient-to-r from-yellow-400/30 to-transparent mb-6" />
        {profileMsg && <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-3 mb-4 text-green-400 text-sm">{profileMsg}</div>}
        <form onSubmit={handleProfileSave}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="text-gray-400 text-sm mb-2 block">Full Name</label>
              <input type="text" value={profile.fullName} onChange={e => setProfile({...profile, fullName: e.target.value})} className={inputClass} />
            </div>
            <div>
              <label className="text-gray-400 text-sm mb-2 block">Username</label>
              <input type="text" value={profile.username} onChange={e => setProfile({...profile, username: e.target.value})} className={inputClass} />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="text-gray-400 text-sm mb-2 block">Email Address</label>
              <input type="email" value={profile.email} onChange={e => setProfile({...profile, email: e.target.value})} className={inputClass} />
            </div>
            <div>
              <label className="text-gray-400 text-sm mb-2 block">Connected Wallet Address</label>
              <input type="text" value={profile.walletAddress} onChange={e => setProfile({...profile, walletAddress: e.target.value})} className={inputClass} placeholder="Connect your wallet on the homepage" />
              <p className="text-gray-500 text-xs mt-1">Your wallet is saved automatically from the presale page.</p>
            </div>
          </div>
          <div className="flex justify-end">
            <button type="submit" className="px-6 py-2.5 rounded-lg font-bold text-black text-sm bg-gradient-to-r from-yellow-400 to-amber-500 hover:from-yellow-300 hover:to-amber-400 transition-all">UPDATE PROFILE</button>
          </div>
        </form>
      </div>

      {/* Change Password */}
      <div className="bg-[#0d1117] border border-[#1a2333] rounded-2xl p-6">
        <h2 className="text-white font-bold text-lg mb-1">Change Password</h2>
        <div className="h-px bg-gradient-to-r from-yellow-400/30 to-transparent mb-6" />
        {pwMsg.text && (
          <div className={`${pwMsg.type === 'error' ? 'bg-red-500/10 border-red-500/30 text-red-400' : 'bg-green-500/10 border-green-500/30 text-green-400'} border rounded-lg p-3 mb-4 text-sm`}>{pwMsg.text}</div>
        )}
        <form onSubmit={handlePasswordChange}>
          <div className="mb-4">
            <label className="text-gray-400 text-sm mb-2 block">Current Password</label>
            <input type="password" value={pwForm.current} onChange={e => setPwForm({...pwForm, current: e.target.value})} className={inputClass} />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="text-gray-400 text-sm mb-2 block">New Password</label>
              <input type="password" value={pwForm.newPw} onChange={e => setPwForm({...pwForm, newPw: e.target.value})} className={inputClass} />
            </div>
            <div>
              <label className="text-gray-400 text-sm mb-2 block">Confirm New Password</label>
              <input type="password" value={pwForm.confirm} onChange={e => setPwForm({...pwForm, confirm: e.target.value})} className={inputClass} />
            </div>
          </div>
          <p className="text-gray-500 text-xs mb-4">Must be at least 6 characters long.</p>
          <div className="flex justify-end">
            <button type="submit" className="px-6 py-2.5 rounded-lg font-bold text-black text-sm bg-gradient-to-r from-yellow-400 to-amber-500 hover:from-yellow-300 hover:to-amber-400 transition-all">CHANGE PASSWORD</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MyProfile;
